import api from '@/api/api.js'
import dayjs from 'dayjs'
import { DataLoadState } from '@/utils/storeUtils.js'
import { eventManager, USER_STATE_CHANGED_EVENT } from '@/eventManager.js'

// Mutation names
const SET_USER_ID = 'setUserId'
const SET_USER_LOAD_STARTED = 'setUserLoadStarted'
const SET_USER_LOAD_FINISHED_SUCCESSFULLY = 'setUserLoadFinishedSuccessfully'
const SET_USER_LOAD_FAILED = 'setUserLoadFailed'
const RESET_USER = 'resetUser'

const SET_MAP_TILES_INFO_LOAD_STARTED = 'setMapTilesInfoLoadStarted'
const SET_MAP_TILES_INFO_LOAD_FINISHED_SUCCESSFULLY = 'setMapTilesInfoLoadFinishedSuccessfully'
const SET_MAP_TILES_INFO_LOAD_FAILED = 'setMapTilesInfoLoadFailed'
const RESET_MAP_TILES_INFO = 'resetMapTilesInfo'

const SET_HUNT_AREAS_LOAD_STARTED = 'setHuntAreasLoadStarted'
const SET_HUNT_AREAS_LOAD_FINISHED_SUCCESSFULLY = 'setHuntAreasLoadFinishedSuccessfully'
const SET_HUNT_AREAS_LOAD_FAILED = 'setHuntAreasLoadFailed'
const RESET_HUNT_AREAS = 'resetHuntAreas'

const SET_HUNTS_LOAD_STARTED = 'setHuntsLoadStarted'
const SET_HUNTS_LOAD_FINISHED_SUCCESSFULLY = 'setHuntsLoadFinishedSuccessfully'
const SET_HUNTS_LOAD_FAILED = 'setHuntsLoadFailed'
const RESET_HUNTS = 'resetHunts'

const SET_GPS_DEVICES_LOAD_STARTED = 'setGPSDevicesLoadStarted'
const SET_GPS_DEVICES_LOAD_FINISHED_SUCCESSFULLY = 'setGPSDevicesLoadFinishedSuccessfully'
const SET_GPS_DEVICES_LOAD_FAILED = 'setGPSDevicesLoadFailed'
const RESET_GPS_DEVICES = 'resetGPSDevices'

const SET_DOG_PROFILES_LOAD_STARTED = 'setDogProfilesLoadStarted'
const SET_DOG_PROFILES_LOAD_FINISHED_SUCCESSFULLY = 'setDogProfilesLoadFinishedSuccessfully'
const SET_DOG_PROFILES_LOAD_FAILED = 'setDogProfilesLoadFailed'
const RESET_DOG_PROFILES = 'resetDogProfiles'

const SET_ACCESS_LOG_LOAD_STARTED = 'setAccessLogLoadStarted'
const SET_ACCESS_LOG_LOAD_FINISHED_SUCCESSFULLY = 'setAccessLogLoadFinishedSuccessfully'
const SET_ACCESS_LOG_LOAD_FAILED = 'setAccessLogLoadFailed'

const SET_ACTIVITY_LOG_LOAD_STARTED = 'setActivityLogLoadStarted'
const SET_ACTIVITY_LOG_LOAD_FINISHED_SUCCESSFULLY = 'setActivityLogLoadFinishedSuccessfully'
const SET_ACTIVITY_LOG_LOAD_FAILED = 'setActivityLogLoadFailed'

const SET_SUBSCRIPTIONS_LOAD_STARTED = 'setSubscriptionsLoadStarted'
const SET_SUBSCRIPTIONS_LOAD_FINISHED_SUCCESSFULLY = 'setSubscriptionsLoadFinishedSuccessfully'
const SET_SUBSCRIPTIONS_LOAD_FAILED = 'setSubscriptionsLoadFailed'
const RESET_SUBSCRIPTIONS = 'resetSubscriptions'

const SET_NOTES_LOAD_STARTED = 'setNotesLoadStarted'
const SET_NOTES_LOAD_FINISHED_SUCCESSFULLY = 'setNotesLoadFinishedSuccessfully'
const SET_NOTES_LOAD_FAILED = 'setNotesLoadFailed'
const RESET_NOTES = 'resetNotes'

const SET_WHB_LOAD_STARTED = 'setWHBLoadStarted'
const SET_WHB_LOAD_FINISHED_SUCCESSFULLY = 'setWHBLoadFinishedSuccessfully'
const SET_WHB_LOAD_FAILED = 'setWHBLoadFailed'
const RESET_WHB = 'resetWHB'

// Getter names
export const IS_LOADING_USER = 'isLoadingUser'
export const GET_USER_ID = 'getUserId'
export const GET_USER = 'getUser'
export const GET_USER_LOAD_ERROR = 'getUserLoadError'

export const IS_LOADING_MAP_TILES_INFO = 'isLoadingMapTilesInfo'
export const GET_MAP_TILES_INFO = 'getMapTilesInfo'
export const GET_MAP_TILES_INFO_LOAD_ERROR = 'getMapTilesInfoLoadError'

export const IS_LOADING_HUNT_AREAS = 'isLoadingHuntAreas'
export const GET_HUNT_AREAS = 'getHuntAreas'
export const GET_HUNT_AREAS_LOAD_ERROR = 'getHuntAreasLoadError'
export const HAS_EMPTY_HUNT_AREAS_LOAD_RESULT = 'hasEmptyHuntAreasLoadResult'

export const IS_LOADING_HUNTS = 'isLoadingHunts'
export const GET_HUNTS = 'getHunts'
export const GET_HUNTS_LOAD_ERROR = 'getHuntsLoadError'
export const HAS_EMPTY_HUNTS_LOAD_RESULT = 'hasEmptyHuntsLoadResult'

export const IS_LOADING_GPS_DEVICES = 'isLoadingGPSDevices'
export const GET_GPS_DEVICES = 'getGPSDevices'
export const GET_GPS_DEVICES_LOAD_ERROR = 'getGPSDevicesLoadError'
export const HAS_EMPTY_GPS_DEVICES_LOAD_RESULT = 'hasEmptyGPSDevicesLoadResult'

export const IS_LOADING_DOG_PROFILES = 'isLoadingDogProfiles'
export const GET_DOG_PROFILES = 'getDogProfiles'
export const GET_DOG_PROFILES_LOAD_ERROR = 'getDogProfilesLoadError'
export const HAS_EMPTY_DOG_PROFILES_LOAD_RESULT = 'hasEmptyDogProfilesLoadResult'

export const IS_LOADING_ACCESS_LOG = 'isLoadingAccessLog'
export const GET_ACCESS_LOG = 'getAccessLog'
export const GET_ACCESS_LOG_LOAD_ERROR = 'getAccessLogLoadError'

export const IS_LOADING_ACTIVITY_LOG = 'isLoadingActivityLog'
export const GET_ACTIVITY_LOG = 'getActivityLog'
export const GET_ACTIVITY_LOG_LOAD_ERROR = 'getActivityLogLoadError'
export const HAS_EMPTY_ACTIVITY_LOG_LOAD_RESULT = 'hasEmptyActivityLogLoadResult'

export const IS_LOADING_SUBSCRIPTIONS = 'isLoadingSubscriptions'
export const GET_SUBSCRIPTIONS = 'getSubscriptions'
export const GET_SUBSCRIPTIONS_LOAD_ERROR = 'getSubscriptionsLoadError'
export const HAS_EMPTY_SUBSCRIPTIONS_LOAD_RESULT = 'hasEmptySubscriptionsLoadResult'

export const IS_LOADING_NOTES = 'isLoadingNotes'
export const GET_NOTES = 'getNotes'
export const GET_NOTES_LOAD_ERROR = 'getNotesLoadError'
export const HAS_EMPTY_NOTES_LOAD_RESULT = 'hasEmptyNotesLoadResult'

export const IS_LOADING_WHB = 'isLoadingWHB'
export const GET_WHB = 'getWHB'
export const GET_WHB_LOAD_ERROR = 'getWHBLoadError'

// Action name
export const SET_USER = 'setUser'
export const LOAD_USER_WITH_ID = 'loadUserWithId'
export const UPDATE_EMAIL = 'updateEmail'
export const UPDATE_PASSWORD = 'updatePassword'
export const LOAD_MAP_TILES_INFO = 'loadMapTilesInfo'
export const LOAD_HUNT_AREAS = 'loadHuntAreas'
export const LOAD_HUNTS = 'loadHunts'
export const INVALIDATE_HUNT_AREAS = 'invalidateHuntAreas'
export const INVALIDATE_HUNTS = 'invalidateHunts'
export const LOAD_GPS_DEVICES = 'loadGPSDevices'
export const LOAD_DOG_PROFILES = 'loadDogProfiles'
export const INVALIDATE_GPS_DEVICES = 'invalidateGPSDevices'
export const UPDATE_PRO_EXPIRATION_DATE = 'updateProExpirationDate'
export const REMOVE_PRO_SUBSCRIPTION = 'removeProSubscription'
export const UPDATE_SUBSCRIPTION_MAP_TILES = 'updateSubscriptionMapTiles'
export const TRANSFER_MAP_TILES = 'transferMapTiles'
export const LOAD_ACCESS_LOG = 'loadAccessLog'
export const LOAD_ACTIVITY_LOG = 'loadActivityLog'
export const DEACTIVATE_USER = 'deactivateUser'
export const LOAD_SUBSCRIPTIONS = 'loadSubscriptions'
export const CANCEL_SUBSCRIPTION_WITH_ID = 'cancelSubscriptionWithId'
export const DELETE_SUBSCRIPTION_WITH_ID = 'deleteSubscriptionWithId'
export const ADD_SUBSCRIPTION = 'addSubscription'
export const RELOAD_GPS_DEVICES = 'reloadGPSDevices'
export const RELOAD_DOG_PROFILES = 'reloadDogProfiles'
export const DELETE_DOG_PROFILE = 'deleteDogProfile'
export const LOAD_NOTES = 'loadNotes'
export const SAVE_NOTE = 'saveNote'
export const DELETE_NOTE = 'deleteNote'
export const LOAD_WHB = 'loadWHB'
export const UPDATE_WHB = 'saveWHB'

// Utils functions
function sortByName(object, secondObject) {
  return object.name.localeCompare(secondObject.name)
}

// Hunt area store implementation
export const UserStore = {
  namespaced: true,

  state: () => ({
    // state must be a function to allow reuse of this store
    userId: null,
    userState: new DataLoadState(),
    mapTilesInfoState: new DataLoadState(),
    huntAreasState: new DataLoadState(),
    huntsState: new DataLoadState(),
    gpsDevicesState: new DataLoadState(),
    dogProfilesState: new DataLoadState(),
    accessLogState: new DataLoadState(),
    activityLogState: new DataLoadState(),
    subscriptionsState: new DataLoadState(),
    notesState: new DataLoadState(),
    whbState: new DataLoadState()
  }),

  mutations: {
    [SET_USER_ID](state, { userId }) {
      state.userId = userId
    },

    [SET_USER](state, { user }) {
      if (!user || !user.id) {
        state.userState = new DataLoadState()
        state.mapTilesInfoState = new DataLoadState()
        state.huntAreasState = new DataLoadState()
        state.huntsState = new DataLoadState()
        state.gpsDevicesState = new DataLoadState()
        state.dogProfilesState = new DataLoadState()
        state.accessLogState = new DataLoadState()
        state.activityLogState = new DataLoadState()
        state.notesState = new DataLoadState()
        state.whbState = new DataLoadState()
        return
      }

      state.userState = new DataLoadState(user.id).stateForLoadFinished(user)
    },

    [SET_USER_LOAD_STARTED](state, { userId }) {
      const dataLoadState = new DataLoadState(userId)
      state.userState = dataLoadState.stateForLoadStarted()
    },

    [SET_USER_LOAD_FINISHED_SUCCESSFULLY](state, { user }) {
      if (user.id !== state.userState.id) {
        // User load is stale, ignore
        return
      }

      state.userState = state.userState.stateForLoadFinished(user)
    },

    [SET_USER_LOAD_FAILED](state, { userId, error }) {
      if (userId !== state.userState.id) {
        // User load is stale, ignore
        return
      }

      state.userState = state.userState.stateForLoadFailed(error)
    },

    [RESET_USER](state, { userId }) {
      if (userId !== state.userState.id) {
        // User has changed, ignore
        return
      }

      state.userState = new DataLoadState()
    },

    [SET_MAP_TILES_INFO_LOAD_STARTED](state, { userId }) {
      const dataLoadState = new DataLoadState(userId)
      state.mapTilesInfoState = dataLoadState.stateForLoadStarted()
    },

    [SET_MAP_TILES_INFO_LOAD_FINISHED_SUCCESSFULLY](state, { userId, mapTilesInfo }) {
      if (userId !== state.mapTilesInfoState.id) {
        // Map tiles info load is stale, ignore
        return
      }

      state.mapTilesInfoState = state.mapTilesInfoState.stateForLoadFinished(mapTilesInfo)
    },

    [SET_MAP_TILES_INFO_LOAD_FAILED](state, { userId, error }) {
      if (userId !== state.mapTilesInfoState.id) {
        // Map tiles info load is stale, ignore
        return
      }

      state.mapTilesInfoState = state.mapTilesInfoState.stateForLoadFailed(error)
    },

    [RESET_MAP_TILES_INFO](state, { userId }) {
      if (userId !== state.userState.id) {
        // User has changed, ignore
        return
      }

      state.mapTilesInfoState = new DataLoadState()
    },

    [SET_HUNT_AREAS_LOAD_STARTED](state, { userId }) {
      const dataLoadState = new DataLoadState(userId)
      state.huntAreasState = dataLoadState.stateForLoadStarted()
    },

    [SET_HUNT_AREAS_LOAD_FINISHED_SUCCESSFULLY](state, { userId, huntAreas }) {
      if (userId !== state.huntAreasState.id) {
        // Hunt areas load is stale, ignore
        return
      }

      state.huntAreasState = state.huntAreasState.stateForLoadFinished(huntAreas)
    },

    [SET_HUNT_AREAS_LOAD_FAILED](state, { userId, error }) {
      if (userId !== state.huntAreasState.id) {
        // Hunt areas load is stale, ignore
        return
      }

      state.huntAreasState = state.huntAreasState.stateForLoadFailed(error)
    },

    [RESET_HUNT_AREAS](state) {
      state.huntAreasState = new DataLoadState()
    },

    [SET_HUNTS_LOAD_STARTED](state, { userId }) {
      const dataLoadState = new DataLoadState(userId)
      state.huntsState = dataLoadState.stateForLoadStarted()
    },

    [SET_HUNTS_LOAD_FINISHED_SUCCESSFULLY](state, { userId, hunts }) {
      if (userId !== state.huntsState.id) {
        // Hunt load is stale, ignore
        return
      }

      state.huntsState = state.huntsState.stateForLoadFinished(hunts)
    },

    [SET_HUNTS_LOAD_FAILED](state, { userId, error }) {
      if (userId !== state.huntsState.id) {
        // Hunt load is stale, ignore
        return
      }

      state.huntsState = state.huntsState.stateForLoadFailed(error)
    },

    [RESET_HUNTS](state) {
      state.huntsState = new DataLoadState()
    },

    [SET_GPS_DEVICES_LOAD_STARTED](state, { userId }) {
      const dataLoadState = new DataLoadState(userId)
      state.gpsDevicesState = dataLoadState.stateForLoadStarted()
    },

    [SET_GPS_DEVICES_LOAD_FINISHED_SUCCESSFULLY](state, { userId, gpsDevices }) {
      if (userId !== state.gpsDevicesState.id) {
        // GPS devices load is stale, ignore
        return
      }

      state.gpsDevicesState = state.gpsDevicesState.stateForLoadFinished(gpsDevices)
    },

    [SET_GPS_DEVICES_LOAD_FAILED](state, { userId, error }) {
      if (userId !== state.gpsDevicesState.id) {
        // GPS devices load is stale, ignore
        return
      }

      state.gpsDevicesState = state.gpsDevicesState.stateForLoadFailed(error)
    },

    [RESET_GPS_DEVICES](state) {
      state.gpsDevicesState = new DataLoadState()
    },

    [SET_DOG_PROFILES_LOAD_STARTED](state, { userId }) {
      const dataLoadState = new DataLoadState(userId)
      state.dogProfilesState = dataLoadState.stateForLoadStarted()
    },

    [SET_DOG_PROFILES_LOAD_FINISHED_SUCCESSFULLY](state, { userId, dogProfiles }) {
      if (userId !== state.dogProfilesState.id) {
        // Dog profiles load is stale, ignore
        return
      }

      state.dogProfilesState = state.dogProfilesState.stateForLoadFinished(dogProfiles)
    },

    [SET_DOG_PROFILES_LOAD_FAILED](state, { userId, error }) {
      if (userId !== state.dogProfilesState.id) {
        // Dog profiles load is stale, ignore
        return
      }

      state.dogProfilesState = state.dogProfilesState.stateForLoadFailed(error)
    },

    [RESET_DOG_PROFILES](state) {
      state.dogProfilesState = new DataLoadState()
    },

    [SET_ACCESS_LOG_LOAD_STARTED](state, { userId }) {
      const dataLoadState = new DataLoadState(userId)
      state.accessLogState = dataLoadState.stateForLoadStarted()
    },

    [SET_ACCESS_LOG_LOAD_FINISHED_SUCCESSFULLY](state, { userId, accessLog }) {
      if (userId !== state.accessLogState.id) {
        // Access log load is stale, ignore
        return
      }

      state.accessLogState = state.accessLogState.stateForLoadFinished(accessLog)
    },

    [SET_ACCESS_LOG_LOAD_FAILED](state, { userId, error }) {
      if (userId !== state.accessLogState.id) {
        // Access log load is stale, ignore
        return
      }

      state.accessLogState = state.accessLogState.stateForLoadFailed(error)
    },

    [SET_ACTIVITY_LOG_LOAD_STARTED](state, { userId }) {
      const dataLoadState = new DataLoadState(userId)
      state.activityLogState = dataLoadState.stateForLoadStarted()
    },

    [SET_ACTIVITY_LOG_LOAD_FINISHED_SUCCESSFULLY](state, { userId, activityLog }) {
      if (userId !== state.activityLogState.id) {
        // Activity log load is stale, ignore
        return
      }

      state.activityLogState = state.activityLogState.stateForLoadFinished(activityLog)
    },

    [SET_ACTIVITY_LOG_LOAD_FAILED](state, { userId, error }) {
      if (userId !== state.activityLogState.id) {
        // Activity log load is stale, ignore
        return
      }

      state.activityLogState = state.activityLogState.stateForLoadFailed(error)
    },

    [SET_SUBSCRIPTIONS_LOAD_STARTED](state, { userId }) {
      const dataLoadState = new DataLoadState(userId)
      state.subscriptionsState = dataLoadState.stateForLoadStarted()
    },

    [SET_SUBSCRIPTIONS_LOAD_FINISHED_SUCCESSFULLY](state, { userId, subscriptions }) {
      if (userId !== state.subscriptionsState.id) {
        // Subscriptions load is stale, ignore
        return
      }

      state.subscriptionsState = state.subscriptionsState.stateForLoadFinished(subscriptions)
    },

    [SET_SUBSCRIPTIONS_LOAD_FAILED](state, { userId, error }) {
      if (userId !== state.subscriptionsState.id) {
        // Subscriptions load is stale, ignore
        return
      }

      state.subscriptionsState = state.subscriptionsState.stateForLoadFailed(error)
    },

    [RESET_SUBSCRIPTIONS](state) {
      state.subscriptionsState = new DataLoadState()
    },

    [SET_NOTES_LOAD_STARTED](state, { userId }) {
      const dataLoadState = new DataLoadState(userId)
      state.notesState = dataLoadState.stateForLoadStarted()
    },

    [SET_NOTES_LOAD_FINISHED_SUCCESSFULLY](state, { userId, notes }) {
      if (userId !== state.notesState.id) {
        // Notes load is stale, ignore
        return
      }

      state.notesState = state.notesState.stateForLoadFinished(notes)
    },

    [SET_NOTES_LOAD_FAILED](state, { userId, error }) {
      if (userId !== state.notesState.id) {
        // Notes load is stale, ignore
        return
      }

      state.notesState = state.notesState.stateForLoadFailed(error)
    },

    [RESET_NOTES](state) {
      state.notesState = new DataLoadState()
    },

    [SET_WHB_LOAD_STARTED](state, { userId }) {
      const dataLoadState = new DataLoadState(userId)
      state.whbState = dataLoadState.stateForLoadStarted()
    },

    [SET_WHB_LOAD_FINISHED_SUCCESSFULLY](state, { userId, whb }) {
      if (userId !== state.whbState.id) {
        // WHB load is stale, ignore
        return
      }

      state.whbState = state.whbState.stateForLoadFinished(whb)
    },

    [SET_WHB_LOAD_FAILED](state, { userId, error }) {
      if (userId !== state.whbState.id) {
        // WHB load is stale, ignore
        return
      }

      state.whbState = state.whbState.stateForLoadFailed(error)
    },

    [RESET_WHB](state) {
      state.whbState = new DataLoadState()
    }
  },

  getters: {
    [GET_USER_ID]: state => {
      return state.userId
    },

    [IS_LOADING_USER]: state => {
      return state.userState.status.loading
    },

    [GET_USER]: state => {
      return state.userState.data
    },

    [GET_USER_LOAD_ERROR]: state => {
      return state.userState.status.error
    },

    [IS_LOADING_MAP_TILES_INFO]: state => {
      return state.mapTilesInfoState.status.loading
    },

    [GET_MAP_TILES_INFO]: state => {
      return state.mapTilesInfoState.data
    },

    [GET_MAP_TILES_INFO_LOAD_ERROR]: state => {
      return state.mapTilesInfoState.status.error
    },

    [IS_LOADING_HUNT_AREAS]: state => {
      return state.huntAreasState.status.loading
    },

    [GET_HUNT_AREAS]: state => {
      return state.huntAreasState.data
    },

    [GET_HUNT_AREAS_LOAD_ERROR]: state => {
      return state.huntAreasState.status.error
    },

    [HAS_EMPTY_HUNT_AREAS_LOAD_RESULT]: state => {
      return state.huntAreasState.status.success && state.huntAreasState.data.length === 0
    },

    [IS_LOADING_HUNTS]: state => {
      return state.huntsState.status.loading
    },

    [GET_HUNTS]: state => {
      return state.huntsState.data
    },

    [GET_HUNTS_LOAD_ERROR]: state => {
      return state.huntsState.status.error
    },

    [HAS_EMPTY_HUNTS_LOAD_RESULT]: state => {
      return state.huntsState.status.success && state.huntsState.data.length === 0
    },

    [IS_LOADING_GPS_DEVICES]: state => {
      return state.gpsDevicesState.status.loading
    },

    [GET_GPS_DEVICES]: state => {
      return state.gpsDevicesState.data
    },

    [GET_GPS_DEVICES_LOAD_ERROR]: state => {
      return state.gpsDevicesState.status.error
    },

    [HAS_EMPTY_GPS_DEVICES_LOAD_RESULT]: state => {
      return state.gpsDevicesState.status.success && state.gpsDevicesState.data.length === 0
    },

    [IS_LOADING_DOG_PROFILES]: state => {
      return state.dogProfilesState.status.loading
    },

    [GET_DOG_PROFILES]: state => {
      return state.dogProfilesState.data
    },

    [GET_DOG_PROFILES_LOAD_ERROR]: state => {
      return state.dogProfilesState.status.error
    },

    [HAS_EMPTY_DOG_PROFILES_LOAD_RESULT]: state => {
      return state.dogProfilesState.status.success && state.dogProfilesState.data.length === 0
    },

    [IS_LOADING_ACCESS_LOG]: state => {
      return state.accessLogState.status.loading
    },

    [GET_ACCESS_LOG]: state => {
      return state.accessLogState.data
    },

    [GET_ACCESS_LOG_LOAD_ERROR]: state => {
      return state.accessLogState.status.error
    },

    [IS_LOADING_ACTIVITY_LOG]: state => {
      return state.activityLogState.status.loading
    },

    [GET_ACTIVITY_LOG]: state => {
      return state.activityLogState.data
    },

    [GET_ACTIVITY_LOG_LOAD_ERROR]: state => {
      return state.activityLogState.status.error
    },

    [HAS_EMPTY_ACTIVITY_LOG_LOAD_RESULT]: state => {
      return state.activityLogState.status.success && state.activityLogState.data.length === 0
    },

    [IS_LOADING_SUBSCRIPTIONS]: state => {
      return state.subscriptionsState.status.loading
    },

    [GET_SUBSCRIPTIONS]: state => {
      return state.subscriptionsState.data
    },

    [GET_SUBSCRIPTIONS_LOAD_ERROR]: state => {
      return state.subscriptionsState.status.error
    },

    [HAS_EMPTY_SUBSCRIPTIONS_LOAD_RESULT]: state => {
      return state.subscriptionsState.status.success && state.subscriptionsState.data.length === 0
    },

    [IS_LOADING_NOTES]: state => {
      return state.notesState.status.loading
    },

    [GET_NOTES]: state => {
      return state.notesState.data
    },

    [GET_NOTES_LOAD_ERROR]: state => {
      return state.notesState.status.error
    },

    [HAS_EMPTY_NOTES_LOAD_RESULT]: state => {
      return state.notesState.status.success && state.notesState.data.length === 0
    },

    [IS_LOADING_WHB]: state => {
      return state.whbState.status.loading
    },

    [GET_WHB]: state => {
      return state.whbState.data
    },

    [GET_WHB_LOAD_ERROR]: state => {
      return state.whbState.status.error
    }
  },

  actions: {
    [LOAD_USER_WITH_ID]: async ({ commit, state }, { userId }) => {
      if (!userId) {
        return
      }

      if (userId === state.userState.id) {
        // User load has already started
        return
      }

      commit(SET_USER_ID, { userId })
      commit(SET_USER_LOAD_STARTED, { userId })

      try {
        const response = await api.get(`admin/users/${userId}`)
        const user = response.data

        commit(SET_USER_LOAD_FINISHED_SUCCESSFULLY, { user })
      } catch (error) {
        commit(SET_USER_LOAD_FAILED, { userId, error })
      }
    },

    [SET_USER]: ({ commit }, { user }) => {
      var userId = null
      if (user) {
        userId = user.id || null
      }

      commit(SET_USER_ID, { userId })
      commit(SET_USER, { user })
    },

    [LOAD_MAP_TILES_INFO]: async ({ commit, state }) => {
      const userId = state.userId
      if (!userId) {
        // No user
        return
      }

      if (userId === state.mapTilesInfoState.id) {
        // Map tiles info load has already started
        return
      }

      commit(SET_MAP_TILES_INFO_LOAD_STARTED, { userId })

      try {
        const response = await api.get(`admin/users/${userId}/maptiles`)

        const mapTilesInfo = response.data
        commit(SET_MAP_TILES_INFO_LOAD_FINISHED_SUCCESSFULLY, { userId, mapTilesInfo })
      } catch (error) {
        commit(SET_MAP_TILES_INFO_LOAD_FAILED, { userId, error })
      }
    },

    [LOAD_HUNT_AREAS]: async ({ commit, state }) => {
      const userId = state.userId
      if (!userId) {
        // No user
        return
      }

      if (userId === state.huntAreasState.id) {
        // Hunt areas load has already started
        return
      }

      commit(SET_HUNT_AREAS_LOAD_STARTED, { userId })

      try {
        const response = await api.get(`admin/users/${userId}/areas`)

        const huntAreas = response.data.slice(0).sort(sortByName)
        commit(SET_HUNT_AREAS_LOAD_FINISHED_SUCCESSFULLY, { userId, huntAreas })
      } catch (error) {
        commit(SET_HUNT_AREAS_LOAD_FAILED, { userId, error })
      }
    },

    [LOAD_HUNTS]: async ({ commit, state }) => {
      const userId = state.userId
      if (!userId) {
        // No user
        return
      }

      if (userId === state.huntsState.id) {
        // Hunts load has already started
        return
      }

      commit(SET_HUNTS_LOAD_STARTED, { userId })

      try {
        const response = await api.get(`admin/users/${userId}/hunts`)

        const hunts = response.data.slice(0).sort(sortByName)
        commit(SET_HUNTS_LOAD_FINISHED_SUCCESSFULLY, { userId, hunts })
      } catch (error) {
        commit(SET_HUNTS_LOAD_FAILED, { userId, error })
      }
    },

    [INVALIDATE_HUNT_AREAS]: ({ commit }) => {
      commit(RESET_HUNT_AREAS)
    },

    [UPDATE_EMAIL]: async ({ commit, state, dispatch }, { email }) => {
      const userId = state.userId
      if (!userId) {
        // No user
        return
      }

      return api.post(`users/${userId}/email`, { email }).then(() => {
        // Reload user data after email has been updated
        commit(RESET_USER, { userId })
        dispatch(LOAD_USER_WITH_ID, { userId })

        // Emit event to allow other stores to reload or delete remove stale data
        eventManager.$emit(USER_STATE_CHANGED_EVENT, { userId })
      })
    },

    [UPDATE_PASSWORD]: async ({ state }, { password }) => {
      const userId = state.userId
      if (!userId) {
        // No user
        return
      }

      return api.post(`users/${userId}/password`, { password }).then(() => {
        // For now nothing more needs to be done
      })
    },

    [INVALIDATE_HUNTS]: ({ commit }) => {
      commit(RESET_HUNTS)
    },

    [LOAD_GPS_DEVICES]: async ({ commit, state }) => {
      const userId = state.userId
      if (!userId) {
        // No user
        return
      }

      if (userId === state.gpsDevicesState.id) {
        // GPS devices load has already started
        return
      }

      commit(SET_GPS_DEVICES_LOAD_STARTED, { userId })

      try {
        const response = await api.get(`admin/users/${userId}/gps`)

        const gpsDevices = response.data
        commit(SET_GPS_DEVICES_LOAD_FINISHED_SUCCESSFULLY, { userId, gpsDevices })
      } catch (error) {
        commit(SET_GPS_DEVICES_LOAD_FAILED, { userId, error })
      }
    },

    [LOAD_DOG_PROFILES]: async ({ commit, state }) => {
      const userId = state.userId
      if (!userId) {
        // No user
        return
      }

      if (userId === state.dogProfilesState.id) {
        // Dog profiles load has already started
        return
      }

      commit(SET_DOG_PROFILES_LOAD_STARTED, { userId })

      try {
        const response = await api.get(`admin/users/${userId}/dogprofile`)

        const dogProfiles = response.data
        commit(SET_DOG_PROFILES_LOAD_FINISHED_SUCCESSFULLY, { userId, dogProfiles })
      } catch (error) {
        commit(SET_DOG_PROFILES_LOAD_FAILED, { userId, error })
      }
    },

    [INVALIDATE_GPS_DEVICES]: ({ commit }) => {
      commit(RESET_GPS_DEVICES)
    },

    [UPDATE_PRO_EXPIRATION_DATE]: ({ commit, state, dispatch }, { newProExpirationDate }) => {
      const userId = state.userId
      if (!userId) {
        // No user
        return
      }

      const newProExpirationDateString = dayjs(newProExpirationDate)
        .utc()
        .toISOString()

      return api
        .post(`admin/users/${userId}/updateProExpirationDate`, {
          newProExpirationDate: newProExpirationDateString
        })
        .then(() => {
          // Reload user data after date has been updated
          commit(RESET_USER, { userId })
          dispatch(LOAD_USER_WITH_ID, { userId })
        })
    },

    [REMOVE_PRO_SUBSCRIPTION]: ({ commit, state, dispatch }) => {
      const userId = state.userId
      if (!userId) {
        // No user
        return
      }

      return api.delete(`admin/users/${userId}/proSunscription`).then(() => {
        // Reload user data after subscription has been removed
        commit(RESET_USER, { userId })
        dispatch(LOAD_USER_WITH_ID, { userId })
      })
    },

    [UPDATE_SUBSCRIPTION_MAP_TILES]: ({ commit, state, dispatch }, { newSubscriptionMapTiles }) => {
      const userId = state.userId
      if (!userId) {
        // No user
        return
      }

      return api
        .post(`admin/users/${userId}/updateSubscriptionMaptiles`, { newSubscriptionMapTiles })
        .then(() => {
          // Reload user data after subscription map tiles has been updated
          commit(RESET_USER, { userId })
          dispatch(LOAD_USER_WITH_ID, { userId })
        })
    },

    [TRANSFER_MAP_TILES]: ({ commit, state, dispatch }, { userQuery }) => {
      const userId = state.userId
      if (!userId) {
        // No user
        return
      }

      return api.post(`admin/users/${userId}/maptiles/transfer`, { userQuery }).then(response => {
        // Reload map tiles info after map tiles have been transfered
        commit(RESET_MAP_TILES_INFO, { userId })
        dispatch(LOAD_MAP_TILES_INFO, { userId })

        // Emit events to allow other stores to reload or delete remove stale data
        const result = response.data
        eventManager.$emit(USER_STATE_CHANGED_EVENT, { userId: result.fromUserId })
        eventManager.$emit(USER_STATE_CHANGED_EVENT, { userId: result.toUserId })
      })
    },

    [LOAD_ACCESS_LOG]: async ({ commit, state }) => {
      const userId = state.userId
      if (!userId) {
        // No user
        return
      }

      if (userId === state.accessLogState.id) {
        // Access log load has already started
        return
      }

      commit(SET_ACCESS_LOG_LOAD_STARTED, { userId })

      try {
        const response = await api.get(`admin/users/${userId}/latestAccess`)

        const accessLog = response.data
        commit(SET_ACCESS_LOG_LOAD_FINISHED_SUCCESSFULLY, { userId, accessLog })
      } catch (error) {
        commit(SET_ACCESS_LOG_LOAD_FAILED, { userId, error })
      }
    },

    [LOAD_ACTIVITY_LOG]: async ({ commit, state }) => {
      const userId = state.userId
      if (!userId) {
        // No user
        return
      }

      if (userId === state.activityLogState.id) {
        // Activity log load has already started
        return
      }

      commit(SET_ACTIVITY_LOG_LOAD_STARTED, { userId })

      try {
        const response = await api.get(`admin/users/${userId}/activityLog`)

        const activityLog = response.data
        commit(SET_ACTIVITY_LOG_LOAD_FINISHED_SUCCESSFULLY, { userId, activityLog })
      } catch (error) {
        commit(SET_ACTIVITY_LOG_LOAD_FAILED, { userId, error })
      }
    },

    [DEACTIVATE_USER]: ({ commit, state, dispatch }) => {
      const userId = state.userId
      if (!userId) {
        // No user
        return
      }

      return api.delete(`admin/users/${userId}`).then(() => {
        // Reload user data after user has been deactivated has been updated
        commit(RESET_USER, { userId })
        dispatch(LOAD_USER_WITH_ID, { userId })
      })
    },

    [LOAD_SUBSCRIPTIONS]: async ({ commit, state }) => {
      const userId = state.userId
      if (!userId) {
        // No user
        return
      }

      if (userId === state.subscriptionsState.id) {
        // Subscriptions load has already started
        return
      }

      commit(SET_SUBSCRIPTIONS_LOAD_STARTED, { userId })

      try {
        const response = await api.get(`admin/users/${userId}/subscriptions`)

        const subscriptions = response.data
        commit(SET_SUBSCRIPTIONS_LOAD_FINISHED_SUCCESSFULLY, { userId, subscriptions })
      } catch (error) {
        commit(SET_SUBSCRIPTIONS_LOAD_FAILED, { userId, error })
      }
    },

    [CANCEL_SUBSCRIPTION_WITH_ID]: ({ commit, dispatch }, { subscriptionId }) => {
      return api.post(`admin/subscriptions/${subscriptionId}/cancel`).then(() => {
        // Always reload subscriptions to make sure the list is correct.
        commit(RESET_SUBSCRIPTIONS)
        dispatch(LOAD_SUBSCRIPTIONS)
      })
    },

    [DELETE_SUBSCRIPTION_WITH_ID]: ({ commit, state, dispatch }, { subscriptionId }) => {
      const userId = state.userState.id

      return api.delete(`admin/subscriptions/${subscriptionId}`).then(() => {
        // Always reload subscriptions to make sure the list is correct.
        commit(RESET_SUBSCRIPTIONS)
        dispatch(LOAD_SUBSCRIPTIONS)

        // Reload user data since Pro date may have changed
        commit(RESET_USER, { userId })
        dispatch(LOAD_USER_WITH_ID, { userId })
      })
    },

    [ADD_SUBSCRIPTION]: ({ commit, state, dispatch }, { type, expires }) => {
      const userId = state.userId
      if (!userId) {
        // No user
        return
      }

      return api.post('admin/subscriptions', { userId, type, expires }).then(() => {
        // Always reload subscriptions to make sure the list is correct.
        commit(RESET_SUBSCRIPTIONS)
        dispatch(LOAD_SUBSCRIPTIONS)

        // Reload user data since Pro date may have changed
        commit(RESET_USER, { userId })
        dispatch(LOAD_USER_WITH_ID, { userId })
      })
    },

    [RELOAD_GPS_DEVICES]: ({ commit, dispatch }) => {
      commit(RESET_GPS_DEVICES)
      dispatch(LOAD_GPS_DEVICES)
    },

    [RELOAD_DOG_PROFILES]: ({ commit, dispatch }) => {
      commit(RESET_DOG_PROFILES)
      dispatch(LOAD_DOG_PROFILES)
    },

    [DELETE_DOG_PROFILE]: ({ commit, dispatch }, { dogProfileId }) => {
      return api.delete(`admin/dogprofiles/${dogProfileId}`).then(() => {
        // Always reload dog profiles to make sure the list is correct.
        commit(RESET_DOG_PROFILES)
        dispatch(LOAD_DOG_PROFILES)
      })
    },

    [LOAD_NOTES]: async ({ commit, state }) => {
      const userId = state.userId
      if (!userId) {
        // No user
        return
      }

      if (userId === state.notesState.id) {
        // Notes load has already started
        return
      }

      commit(SET_NOTES_LOAD_STARTED, { userId })

      try {
        const response = await api.get(`admin/users/${userId}/notes`)

        const notes = response.data
        commit(SET_NOTES_LOAD_FINISHED_SUCCESSFULLY, { userId, notes })
      } catch (error) {
        commit(SET_NOTES_LOAD_FAILED, { userId, error })
      }
    },

    [SAVE_NOTE]: ({ commit, state, dispatch }, { id, note }) => {
      const userId = state.userId
      if (!userId) {
        // No user
        return
      }

      if (id) {
        return api.put(`admin/users/notes/${id}`, { userId, note }).then(() => {
          // Always reload notes to make sure the list is correct.
          commit(RESET_NOTES)
          dispatch(LOAD_NOTES)
        })
      }

      return api.post('admin/users/notes', { userId, note }).then(() => {
        // Always reload notes to make sure the list is correct.
        commit(RESET_NOTES)
        dispatch(LOAD_NOTES)
      })
    },

    [DELETE_NOTE]: ({ commit, dispatch }, { userNoteId }) => {
      return api.delete(`admin/users/notes/${userNoteId}`).then(() => {
        // Always reload notes to make sure the list is correct.
        commit(RESET_NOTES)
        dispatch(LOAD_NOTES)
      })
    },

    [LOAD_WHB]: async ({ commit, state }) => {
      const userId = state.userId
      if (!userId) {
        // No user
        return
      }

      if (userId === state.whbState.id) {
        // WHB load has already started
        return
      }

      commit(SET_WHB_LOAD_STARTED, { userId })

      try {
        const response = await api.get(`admin/users/${userId}/whb`)

        const whb = response.data
        commit(SET_WHB_LOAD_FINISHED_SUCCESSFULLY, { userId, whb })
      } catch (error) {
        commit(SET_WHB_LOAD_FAILED, { userId, error })
      }
    },

    [UPDATE_WHB]: ({ commit, state, dispatch }, { isBusinessUser, expiresDay }) => {
      const userId = state.userId
      if (!userId) {
        // No user
        return
      }

      return api.post(`admin/users/${userId}/whb`, { isBusinessUser, expiresDay }).then(() => {
        // Always reload whb to make sure the list is correct.
        commit(RESET_WHB)
        dispatch(LOAD_WHB)
      })
    }
  }
}
